import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { isOrderReplaced } from "../../utils/orderInfo";
import { Bold } from "../common/Bold";
export var DamageMissingIA = function DamageMissingIA(_ref) {
  var context = _ref.context;
  var isReplacement = isOrderReplaced(context);
  if (isReplacement) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "LZxyBC",
      defaultMessage: [{
        "type": 0,
        "value": "Lorsqu'un commerçant signale un article comme manquant ou endommagé, vous recevez une notification par e-mail et sur la "
      }, {
        "children": [{
          "type": 0,
          "value": "page des détails de la commande"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". Ce rapport reprend les articles et les quantités indiqués comme manquants ou endommagés. Des photos des dommages sont ajoutées aux articles signalés comme endommagés. Ces articles sont automatiquement supprimés de la facture du commerçant."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder, _context$brandOrder$b;
          return _OrderLinkFormatting(chunks, (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "DpO7YM",
      defaultMessage: [{
        "type": 0,
        "value": "Si vous pensez qu'un commerçant a injustement indiqué un article comme manquant ou endommagé, vous pouvez contester le signalement."
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "G5ytU0",
      defaultMessage: [{
        "type": 0,
        "value": "Si vous avez choisi de recevoir vos paiements le jour suivant, vous pouvez contester le signalement directement dans le "
      }, {
        "children": [{
          "type": 0,
          "value": "rapport de problème"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " sur la "
      }, {
        "children": [{
          "type": 0,
          "value": "page des détails de la commande"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". Si vous avez choisi une autre option de paiement, vous pouvez contacter notre équipe d'assistance pour obtenir de l'aide en cas de litige."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder2, _context$brandOrder2$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder2 = context.brandOrder) === null || _context$brandOrder2 === void 0 ? void 0 : (_context$brandOrder2$ = _context$brandOrder2.brand_order) === null || _context$brandOrder2$ === void 0 ? void 0 : _context$brandOrder2$.token);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "b3fCmJ",
      defaultMessage: [{
        "type": 0,
        "value": "Lorsqu'un commerçant signale un article comme manquant ou endommagé, vous recevez une notification par e-mail et sur la "
      }, {
        "children": [{
          "type": 0,
          "value": "page des détails de la commande"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". Ce rapport reprend les articles et les quantités indiqués comme manquants ou endommagés. Des photos des dommages sont ajoutées aux articles signalés comme endommagés. Ces articles sont automatiquement supprimés de la facture initiale du commerçant et déduits de votre paiement."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder3, _context$brandOrder3$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder3 = context.brandOrder) === null || _context$brandOrder3 === void 0 ? void 0 : (_context$brandOrder3$ = _context$brandOrder3.brand_order) === null || _context$brandOrder3$ === void 0 ? void 0 : _context$brandOrder3$.token);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+plhEc",
      defaultMessage: [{
        "type": 0,
        "value": "Si le commerçant a demandé le remplacement de ces articles, une nouvelle commande a été créée automatiquement. Vous la trouverez sur votre page "
      }, {
        "children": [{
          "type": 0,
          "value": "Commandes"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ". Lorsque vous aurez traité la commande de remplacement, vous recevrez un autre paiement."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "DpO7YM",
      defaultMessage: [{
        "type": 0,
        "value": "Si vous pensez qu'un commerçant a injustement indiqué un article comme manquant ou endommagé, vous pouvez contester le signalement."
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "G5ytU0",
      defaultMessage: [{
        "type": 0,
        "value": "Si vous avez choisi de recevoir vos paiements le jour suivant, vous pouvez contester le signalement directement dans le "
      }, {
        "children": [{
          "type": 0,
          "value": "rapport de problème"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " sur la "
      }, {
        "children": [{
          "type": 0,
          "value": "page des détails de la commande"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ". Si vous avez choisi une autre option de paiement, vous pouvez contacter notre équipe d'assistance pour obtenir de l'aide en cas de litige."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          var _context$brandOrder4, _context$brandOrder4$;
          return _OrderLinkFormatting(chunks, (_context$brandOrder4 = context.brandOrder) === null || _context$brandOrder4 === void 0 ? void 0 : (_context$brandOrder4$ = _context$brandOrder4.brand_order) === null || _context$brandOrder4$ === void 0 ? void 0 : _context$brandOrder4$.token);
        }
      }
    })));
  }
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Bold, null, chunks);
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};